import { render, staticRenderFns } from "./DetailsofTreatment.vue?vue&type=template&id=7960d692&scoped=true&"
import script from "./DetailsofTreatment.vue?vue&type=script&lang=js&"
export * from "./DetailsofTreatment.vue?vue&type=script&lang=js&"
import style0 from "./DetailsofTreatment.vue?vue&type=style&index=0&id=7960d692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960d692",
  null
  
)

export default component.exports